const registerShopEN = {
	step: "Step {{step}} of 3",

	step1: {
		title: "Create Admin Account",
		subtitle: "Set the password for your owner account and we'll take you straight to your calendar.",
		invitedTo: "Setting up",
		email: "Email",
		sectionAbout: "About you",
		sectionSecurity: "Security",
		sectionBusiness: "Your business",
		category: "Category",
		subCategory: "Subcategory",
		categoryPlaceholder: "Business category",
		subCategoryPlaceholder: "Subcategory",
		firstName: "First name",
		lastName: "Last name",
		phone: "Phone number",
		password: "Password",
		confirmPassword: "Confirm Password",
		upload:"Upload",
		remember: "Remember me",
		register: "Register",
		registering: "Registering...",
		referralCode: "Referral Code",
		ownerTakesBookings: {
			label: "Do you take appointments yourself?",
			yes: "Yes, I do",
			yesHint: "You get your own calendar customers can book.",
			no: "No, my staff do",
			noHint: "You run the shop. Your staff take the appointments.",
			noteYes: "You can add staff and their own calendars at any time.",
			noteNo: "You'll invite your first staff member next — they get their own login and calendar, and your plan still covers the first one.",
		},
		acceptTerms: "I agree to the",
		termsLink: "Terms & Conditions",
	},

	errors: {
		fillRequired: "Almost there! Please fill in the required fields to continue.",
		passwordMatch: "Those passwords don't match — give it another look.",
		uploadImages: "Add at least one photo to finish setting up.",
		invalidInvite: "This invite link isn't valid anymore. Please request a new one.",
		mustAcceptTerms: "Please accept the Terms & Conditions to continue.",
	},

	success: {
		adminCreated: "You're all set! Now let's set up your shop.",
		returning: "Welcome back! Let's keep setting up your shop.",
	},

	days: {
		Monday: "Monday",
		Tuesday: "Tuesday",
		Wednesday: "Wednesday",
		Thursday: "Thursday",
		Friday: "Friday",
		Saturday: "Saturday",
		Sunday: "Sunday",
	},
};

export default registerShopEN;
